module.exports = __webpack_public_path__ + "static/media/Rename.37819b88.svg";